<div class="p-sm-5 p-3 d-flex flex-column justify-content-between h-100">
  <div class="d-flex justify-content-between">
    <img src="/assets/img/mac-logo-menu.svg" alt="MAC Logo">
    <img src="/assets/img/faq-open-btn.svg" alt="Close" (click)="leaveMenu()">
  </div>

  <div class="row">
    <div class="d-flex flex-column col text-uppercase lh-1 ml-50">
      <p class="neon-text" (click)="navigateTo('about')">About</p>
      <p class="neon-text">Gallery</p>
      <p class="neon-text" (click)="navigateTo('partner')">Partner</p>
      <p class="neon-text" (click)="navigateTo('artists')">Artist</p>
      <p class="neon-text" (click)="navigateTo('services')">Services</p>
      <p class="neon-text" (click)="navigateTo('faq')">Faq</p>
      <p class="neon-text" (click)="navigateTo('footer')">Contact</p>
    </div>
    <div class="d-flex justify-content-center align-items-center col" id="our-vision" style="margin: auto; font-family: 'Power';">(our vision . our dimensions . us)</div>
  </div>

  <div class="d-flex justify-content-between align-items-end ml-50 menu-bottom" style="font-family: 'Power';">
    <div class="d-flex gap-sm-5 flex-column flex-sm-row">
      <a href="">Instagram</a>

      <a href="">Linkedin</a>

      <a href="">X</a>
    </div>

    <div class="text-end lh-sm">
      <p class="m-0">info&commat;mecenateartcorner.com</p>
      <p class="m-0">76/B VIA MECENATE, MILAN, ITALY</p>
    </div>
  </div>
</div>